module.exports = __webpack_public_path__ + "7f3348ea51b62a8859e17a3c4bd1ee6f.svg";